'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.departureServicesDataRequested = departureServicesDataRequested;
exports.departureServicesDataReceived = departureServicesDataReceived;
exports.departureServicesDataRequestFailed = departureServicesDataRequestFailed;
var DEPARTURE_SERVICES_DATA_REQUESTED = exports.DEPARTURE_SERVICES_DATA_REQUESTED = 'DEPARTURE_SERVICES_DATA_REQUESTED';

function departureServicesDataRequested() {
    return {
        type: DEPARTURE_SERVICES_DATA_REQUESTED
    };
}

var DEPARTURE_SERVICES_DATA_RECEIVED = exports.DEPARTURE_SERVICES_DATA_RECEIVED = 'DEPARTURE_SERVICES_DATA_RECEIVED';

function departureServicesDataReceived(newDepartureServicesData) {
    return {
        type: DEPARTURE_SERVICES_DATA_RECEIVED,
        newDepartureServicesData: newDepartureServicesData
    };
}

var DEPARTURE_SERVICES_DATA_REQUEST_FAILED = exports.DEPARTURE_SERVICES_DATA_REQUEST_FAILED = 'DEPARTURE_SERVICES_DATA_REQUEST_FAILED';

function departureServicesDataRequestFailed(error) {
    return {
        type: DEPARTURE_SERVICES_DATA_REQUEST_FAILED,
        error: error
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/departureServicesDataActions.js
// module id = 152
// module chunks = 0